import { Wheat, Hand, Clock3 } from "lucide-react";
import { IMAGES } from "../data/site";
import { Reveal, ClipReveal, Chapter } from "./Reveal";

const HIGHLIGHTS = [
  { icon: Clock3, title: "48–72 Hours", desc: "Slow-fermented for flavour and a lighter base." },
  { icon: Wheat, title: "Cereals & Lactic Ferments", desc: "A special dough blend that's crisp and easier to digest." },
  { icon: Hand, title: "Hand-Stretched", desc: "Homemade and stretched by hand, every single day." },
];

export default function PinsaSection() {
  return (
    <section id="pinsa" data-testid="pinsa-section" className="mx-auto max-w-7xl px-5 pb-24 md:px-10 md:pb-36">
      <Chapter number="2" title="Our Pinsa" />
      <div className="mt-10 grid items-center gap-12 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <Reveal>
            <h2 className="font-serif text-4xl font-bold leading-tight tracking-tight md:text-6xl">
              Not just pizza. <span className="italic text-ember">Pinsa.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 max-w-xl text-base leading-relaxed text-charcoal/65 md:text-lg" data-testid="pinsa-story">
              Our pinsa starts with a special dough of blended cereals and lactic ferments, slow-fermented
              for 48 to 72 hours. The result is a base that's lighter, crispier and easier to digest than
              traditional pizza — hand-stretched, homemade and baked fresh for every order. Beautiful on the
              board, even better on the plate.
            </p>
          </Reveal>
          <div className="mt-12 grid gap-px overflow-hidden border border-charcoal/10 bg-charcoal/10 sm:grid-cols-3">
            {HIGHLIGHTS.map((h, i) => (
              <Reveal key={h.title} delay={0.08 * i} className="h-full">
                <div data-testid={`pinsa-highlight-${i}`} className="flex h-full flex-col gap-3 bg-cream p-6 transition-transform duration-300 hover:-translate-y-1.5">
                  <h.icon size={24} className="text-ember" />
                  <h3 className="font-display text-base uppercase tracking-wider">{h.title}</h3>
                  <p className="text-sm text-charcoal/55">{h.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
        <div className="lg:col-span-5">
          <ClipReveal>
            <div className="group relative aspect-[3/4] max-h-[60vh] overflow-hidden">
              <img src={IMAGES.dough} alt="Hand-stretched fermented dough at Croudace Pizza & Burger" className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal/50 to-transparent" />
              <p className="absolute bottom-5 left-5 text-xs font-semibold uppercase tracking-[0.3em] text-gold">
                Fermented 48–72 hours
              </p>
            </div>
          </ClipReveal>
        </div>
      </div>
    </section>
  );
}
